namespace RedBullMOBILE360.CVM {
    export class OfferRedemptionColumns {
        static columnsKey = 'CVM.OfferRedemption';
    }
}